var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDragIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 6.66667C4.6 6.66667 4 7.26667 4 8C4 8.73333 4.6 9.33333 5.33333 9.33333C6.06667 9.33333 6.66667 8.73333 6.66667 8C6.66667 7.26667 6.06667 6.66667 5.33333 6.66667Z",
    fill: "#395ABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 6.66667C9.93333 6.66667 9.33333 7.26667 9.33333 8C9.33333 8.73333 9.93333 9.33333 10.6667 9.33333C11.4 9.33333 12 8.73333 12 8C12 7.26667 11.4 6.66667 10.6667 6.66667Z",
    fill: "#395ABF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 2C4.6 2 4 2.6 4 3.33333C4 4.06667 4.6 4.66667 5.33333 4.66667C6.06667 4.66667 6.66667 4.06667 6.66667 3.33333C6.66667 2.6 6.06667 2 5.33333 2Z",
    fill: "#395ABF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2C9.93333 2 9.33333 2.6 9.33333 3.33333C9.33333 4.06667 9.93333 4.66667 10.6667 4.66667C11.4 4.66667 12 4.06667 12 3.33333C12 2.6 11.4 2 10.6667 2Z",
    fill: "#395ABF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 11.3333C4.6 11.3333 4 11.9333 4 12.6667C4 13.4 4.6 14 5.33333 14C6.06667 14 6.66667 13.4 6.66667 12.6667C6.66667 11.9333 6.06667 11.3333 5.33333 11.3333Z",
    fill: "#395ABF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.3333C9.93333 11.3333 9.33333 11.9333 9.33333 12.6667C9.33333 13.4 9.93333 14 10.6667 14C11.4 14 12 13.4 12 12.6667C12 11.9333 11.4 11.3333 10.6667 11.3333Z",
    fill: "#395ABF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDragIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/drag-icon.b1bfdbf5.svg";
export { ForwardRef as ReactComponent };